module.exports = fox._r("fonts/museosanscyrl_0-webfont.svg", __webpack_public_path__ + "fonts/museosanscyrl_0-webfont.svg");


//////////////////
// WEBPACK FOOTER
// ./fonts/museosanscyrl_0-webfont.svg
// module id = 580
// module chunks = 2